// extracted by mini-css-extract-plugin
module.exports = {"stripe__label":"input_stripe__label__1xwAu","stripe__text__input":"input_stripe__text__input__29wKq"};